<section class="flex flex-col gap-8">
  <h2 class="heading-4">Your repair</h2>

  <p class="body">Select the method that works best for you</p>
  <p class="hint">(Options depend on your product and local availability.)</p>
</section>

@if (vm.isEligibleForReplacement) {
  <section class="replacement" data-testid="replacement-message">
    <p class="body">You’re eligible for a replacement.</p>
  </section>
}

<div class="service-option-list" data-testid="service-option-list">
  @for (option of vm.serviceOptions; track option.serviceOptionID; let index = $index) {
    <label class="p-24 sm-p-16" role="presentation">
      <input
        class="visually-hidden"
        type="radio"
        [id]="option.serviceOptionID"
        [ngModel]="selectedOption"
        [ngModelOptions]="{ standalone: true }"
        name="option"
        [value]="option"
        (ngModelChange)="selectedOption = $event"
        [attr.aria-label]="option.display.label"
        [attr.data-testid]="'service-option-' + index"
      />

      <div class="flex gap-8">
        <div class="flex flex-col gap-8">
          @let selected = selectedOption?.serviceOptionID === option.serviceOptionID;
          @if (option.display.image) {
            <img
              [hidden]="selected"
              [src]="'assets/images/service-options/' + option.display.image + '_default.svg'"
              alt=""
            />

            <img
              [hidden]="!selected"
              [src]="'assets/images/service-options/' + option.display.image + '_active.svg'"
              alt=""
            />
          } @else if (option.display.icon) {
            <i [class]="'fa-light ' + option.display.icon"></i>
          }

          @if (selected) {
            <img class="selected-check" src="assets/images/service-options/checked.svg" alt="" />
          }

          <p class="body large">
            {{ option.display.label }}
          </p>
        </div>
      </div>
    </label>
  }
</div>

@if (!selectedOption && formSubmitted()) {
  <section class="error" data-testid="service-option-empty-error">
    <i class="fa-light fa-circle-exclamation"></i>
    <p class="body">Select an option to continue.</p>
  </section>
}

@if (vm.isGameReplacement) {
  <section class="plan-will-end mt-4" data-testid="plan-will-end">
    <i class="fa-light fa-circle-info"></i>

    <p class="body">Your plan will end, in line with the terms and conditions.</p>
  </section>
}

@if (selectedOption) {
  <p class="body">
    @for (line of selectedOption.display.description; track line) {
      <span class="description-line">{{ line }} </span>
    }
  </p>
}

@if (vm.isGameReplacement) {
  <section class="faqs" data-testid="faqs-section">
    <h2 class="heading-5">Frequently asked questions</h2>

    <section class="flex-col mt-24 gap-8">
      @for (faq of gameReplacementQA; track faq.question) {
        <section class="panel" [class.open]="faq.open" data-testid="faq-panel">
          <section class="header">
            <button type="button" class="block full-width label p-16" (click)="faq.open = !faq.open">
              <div class="sm-flex-col label">
                {{ faq.question }}
              </div>

              <i class="fa-light ml-8" [class.fa-chevron-up]="faq.open" [class.fa-chevron-down]="!faq.open"></i>
            </button>
          </section>

          <section class="content flex-col" [appAnimateOpen]="faq.open">
            <section>
              <p class="body">
                {{ faq.answer }}
              </p>
            </section>
          </section>
        </section>
      }
    </section>
  </section>
}

<div class="divider" [class.no-selection]="!selectedOption"></div>

<input name="option" hidden [ngModel]="selectedOption" />
